export default __webpack_public_path__ + "static/home-page-narragansett-crowd-765276dc610d04e4212902289be414b4.webp";